import React from 'react'
import classes from './Share.module.scss';
import globalJSON from 'data/global.json'

import FacebookIcon from 'components/App/SocialIcons/FacebookIcon/FacebookIcon';
import TwitterIcon from 'components/App/SocialIcons/TwitterIcon/TwitterIcon';
// import EmailIcon from 'components/App/SocialIcons/EmailIcon/EmailIcon';

function Share({content, pageMeta}) {

    return (
        <section id={"share"} className={classes.share}>
            <h5 className={classes.share__small_title}>{content.titleSmall}</h5>
            <h2 className={classes.share__title}>{content.title}</h2>
            <div className={classes.share__icons}>
                <TwitterIcon twitterDescription={content.twitter.message} twitterDescriptionVia={content.twitter.via} url={`${globalJSON.live_url}${process.env.PUBLIC_URL}`}/>
                <FacebookIcon facebookDescription={content.facebookMessage} url={`${globalJSON.live_url}${process.env.PUBLIC_URL}`} />
                {/* <EmailIcon /> */}
            </div>
        </section>
	)

}

export default Share;